import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
	BroadcastMessageType,
	IBroadcastMessage,
} from '@app/services/broadcast/change-organization/broadcastMessage.model';

@Injectable({
	providedIn: 'root',
})
export class BroadcastMessageService {
	public broadcastChannel: BroadcastChannel;
	public broadcastMessage$: Subject<IBroadcastMessage> = new Subject<IBroadcastMessage>();
	constructor() {
		this.initOrganizationChangedBroadcast();
	}

	public publishMessage(message: IBroadcastMessage): void {
		this.broadcastChannel.postMessage(message);
	}

	public selectMessagesByType(type: string): Observable<IBroadcastMessage> {
		return this.broadcastMessage$.pipe(filter((message) => message.type === type));
	}

	private initOrganizationChangedBroadcast(): void {
		this.broadcastChannel = new BroadcastChannel(BroadcastMessageType.organizationChanged);
		this.broadcastChannel.onmessage = (message) => {
			this.broadcastMessage$.next(message.data);
		};
	}
}
